// src/label/src/label.tsx
import { cx } from "class-variance-authority";
import { jsx } from "react/jsx-runtime";
var Label = ({
  labelId,
  hideLabel,
  label,
  disabled = false
}) => /* @__PURE__ */ jsx(
  "label",
  {
    className: cx(`w-fit text-sm`, {
      "sr-only": hideLabel,
      "text-interactive-disabled": disabled,
      "text-surface-dark": !disabled
    }),
    htmlFor: labelId,
    children: label
  }
);

export {
  Label
};
